// extracted by mini-css-extract-plugin
export var black = "_t-6";
export var brand = "_t-1";
export var ddefault = "_t-0";
export var error = "_t-3";
export var gray = "_t-2";
export var highContrast = "_t-8";
export var outline = "_t-7";
export var success = "_t-5";
export var warning = "_t-4";